<div id="main-content">

    <!-- Breadcrumb on the left -->
    <nav aria-label="breadcrumb" class="px-5 mb-0">
      <ol class="breadcrumb mb-0">
        <li class="breadcrumb-item"><a [routerLink]="['/home']">Workspaces</a></li>
        <li class="breadcrumb-item"><a [routerLink]="newUrl">Visual</a></li>
        <li class="breadcrumb-item active" aria-current="page">Dataflow</li>
      </ol>
    </nav>
  
    <!-- Centered text -->
    <div class="flex-grow-1 d-flex justify-content-center">
      <p class="fs-5 mb-4 text-center">Dataflow Information</p>
    </div>


  <div class="d-flex flex-column align-items-center">
  <div class="card" style="max-width: 50%; width: 100%;" *ngIf="dataflow; else noDataflow">
    <div class="card-body">
      <!-- Dataflow Details -->
      <ul class="list-group mb-3">
        <li class="list-group-item">
          <strong>Dislpay Name:</strong> {{ dataflow.displayName }}
        </li>
        <li class="list-group-item">
            <strong>Description:</strong> {{ dataflow.description }}
          </li>
          <li class="list-group-item">
            <strong>Configured By:</strong> {{ dataflow.configuredBy }}
          </li>
          <li class="list-group-item">
            <strong>Generation:</strong> {{ dataflow.generation }}
          </li>
      </ul>
    </div>
  </div>
</div>
</div>

<!-- Fallback content if dataflow is not available -->
<ng-template #noDataflow>
  <div class="alert alert-warning text-center" style="max-width: 600px; margin: 0 auto;">
    No dataflow available.
  </div>
</ng-template>
